import { isEmptyString } from './string'

/**
 * Takes a value which can be either a single value or an array of values
 * and always returns an array of this value
 */
export function toArray<Value extends string | number>(
  value?: Value | Value[]
): Value[] | undefined {
  if (!value) return

  if (Array.isArray(value)) {
    // Don't return anything if the array is empty
    if (value.length === 0) return // TODO: Should maybe return []?
    return value
  }

  // Don't return anything if it's an empty string
  if (typeof value === 'string') {
    if (isEmptyString(value)) return
  }

  return [value]
}
